"use strict";/*
 * This file defines a basic module that provides some information.
 *
 * Files within the public/scripts/ directory get meta-replaced by default (thus @{...} gets resolved within the
 * grunt-tasks).
 */
define("plugin/emoji-extended",function(){var a="1.1.1+1238".split("+");return{id:"nodebb-plugin-emoji-extended",name:"Emoji Extended",version:a[0],versionMeta:null!=a[1]?a[1]:null}});